/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

const mergeCommandIntelligenceHandles = matches => {
  const merged = {};

  (matches ?? []).forEach(match => {
    const handle = match?.handle?.commandIntelligence;

    if (!handle || typeof handle !== 'object') {
      return;
    }

    Object.assign(merged, handle);
  });

  return merged;
};

export const resolveRouteContextFromMatches = ({ matches, routeParams = {}, pathname = '' } = {}) => {
  const routeHandle = mergeCommandIntelligenceHandles(matches);
  const normalizedParams =
    routeParams && typeof routeParams === 'object' && !Array.isArray(routeParams) ? routeParams : {};

  return {
    pathname: typeof pathname === 'string' ? pathname : '',
    routeHandle,
    routeParams: normalizedParams,
  };
};
